import { Button, Divider, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import React from 'react';
import dev from '../../../../assets/images/icons/development.gif';
import Paper from '@mui/material/Paper';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailIcon from '@mui/icons-material/Mail';
import LanguageIcon from '@mui/icons-material/Language';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import YouTubeIcon from '@mui/icons-material/YouTube';
import MapContainer from './MapContainer';
import './PublicFooter.css';

const importantWebsites = [
    {
        name: 'Directorate of Primary Education',
        url: 'https://www.dpe.gov.bd/',
    },
    { name: 'Sangsad Bangladesh', url: 'https://www.parliament.gov.bd/' },
    { name: 'NCTB', url: 'http://www.nctb.gov.bd/' },
    { name: 'DSHE', url: 'http://www.dshe.gov.bd/' },
    { name: 'BANBEIS', url: 'https://www.banbeis.gov.bd/' },
    { name: 'Khan Academy Bangla', url: 'https://bn.khanacademy.org/' },
];
const PublicFooter = () => (
    <>
        <Box
            sx={{
                backgroundColor: '#1a1a1a',
                marginTop: '1.5rem',
                // backgroundColor: 'rgb(244, 80, 80)',
                // backgroundImage: 'linear-gradient(90deg, rgba(244, 80, 80, 1) -100%, rgba(55, 166, 71, 1) 110%)'
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    sx={{ gap: 6, pb: 2 }}
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent={'space-between'}
                >
                    <Stack>
                        <Typography
                            variant="h2"
                            sx={{
                                textShadow: '0 0 10px #3C486B',
                                color: '#f0f0f0',
                                fontWeight: 'bold',
                                paddingY: 3,
                            }}
                        >
                            Important Websites
                        </Typography>
                        <Stack>
                            <Box
                                style={{
                                    width: '100%',
                                    maxWidth: 360,
                                    margin: '0',
                                    padding: '0',
                                }}
                            >
                                <Stack direction={'column'} spacing={2.4}>
                                    {importantWebsites?.map((item) => (
                                        <div key={item.name}>
                                            <a
                                                style={{
                                                    textDecoration: 'none',
                                                }}
                                                href={item.url}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.3rem',
                                                    }}
                                                >
                                                    <OpenInNewIcon
                                                        sx={{
                                                            color: '#F0F0F0',
                                                        }}
                                                        fontSize="small"
                                                    />
                                                    <span
                                                        style={{
                                                            color: '#F0F0F0',
                                                        }}
                                                    >
                                                        {' '}
                                                        {item.name}
                                                    </span>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </Stack>
                            </Box>
                        </Stack>
                    </Stack>
                    <Stack sx={{ flexGrow: 1 }}>
                        <Typography
                            variant="h2"
                            sx={{
                                color: '#f0f0f0',
                                textShadow: '0 0 10px #3C486B',
                                fontWeight: 'bold',
                                paddingY: 3,
                            }}
                        >
                            Our Location
                        </Typography>

                        <Stack>
                            <Paper
                                sx={{
                                    boxShadow:
                                        'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                }}
                            >
                                <MapContainer />
                            </Paper>
                        </Stack>
                    </Stack>
                    <Stack sx={{ maxWidth: '30rem' }}>
                        <Typography
                            variant="h2"
                            sx={{
                                color: '#f0f0f0',
                                textShadow: '0 0 10px #3C486B',
                                fontWeight: 'bold',
                                paddingY: 3,
                            }}
                        >
                            Contact Us
                        </Typography>
                        <h3
                            style={{
                                fontFamily: 'Ubuntu',
                                color: '#F0F0F0',
                                fontWeight: 'bold',
                                paddingBottom: '1rem',
                                margin: '0',
                            }}
                        >
                            {' '}
                            Charupath Hateykhari School (CHS)
                        </h3>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            spacing={2}
                        >
                            <Stack>
                                <h3
                                    style={{
                                        color: 'tomato',
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem',
                                        paddingBottom: '0.9rem',
                                        margin: '0',
                                    }}
                                >
                                    {' '}
                                    Rupnagar Branch
                                </h3>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.3rem',
                                    }}
                                >
                                    <BusinessIcon
                                        sx={{ color: '#F0F0F0' }}
                                        fontSize="small"
                                    />
                                    <span style={{ color: '#F0F0F0' }}>
                                        {' '}
                                        House-32, Road-12, Rupnagar R/A,
                                        Mirpur-2, Dhaka-1216
                                    </span>
                                </div>
                                <div
                                    style={{
                                        paddingTop: '1rem',
                                        alignItems: 'center',
                                        gap: '0.3rem',
                                    }}
                                >
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href="tel:+8801711969580"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <LocalPhoneIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                +88 01711 969580
                                            </span>
                                        </div>
                                    </a>
                                    {/* <a
                                        style={{ textDecoration: 'none' }}
                                        href="tel:+8801628313131"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <LocalPhoneIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                +88 01628 313131
                                            </span>
                                        </div>
                                    </a> */}
                                </div>
                                <div
                                    style={{
                                        paddingTop: '1rem',
                                        alignItems: 'center',
                                        gap: '1rem',
                                    }}
                                >
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href="mailto:info@chs.edu.bd"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <MailIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                info@chs.edu.bd
                                            </span>
                                        </div>
                                    </a>
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href="https://chs.edu.bd/"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <LanguageIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                chs.edu.bd
                                            </span>
                                        </div>
                                    </a>
                                </div>
                                {/* <Stack
                                    justifyContent={'center'}
                                    direction={'column'}
                                    alignItems={'center'}
                                    sx={{ display: 'flex', mt: '0.2rem' }}
                                >
                                    <h3 style={{ color: '#F0F0F0', fontWeight: 'bold', marginBottom: '8px' }}>Social Media Links</h3>
                                </Stack>
                                <div>
                                    <div>
                                        <a
                                            target="_blank"
                                            style={{ textDecoration: 'none' }}
                                            href="https://www.facebook.com/profile.php?id=100057644492310" rel="noreferrer"
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                                <FacebookIcon sx={{ color: '#F0F0F0' }} fontSize="medium" />
                                                <span style={{ color: '#F0F0F0' }}> Charupath Hateykhari School</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div>
                                        <a
                                            target="_blank"
                                            style={{ textDecoration: 'none' }}
                                            href="https://www.youtube.com/@md.hamidulislammintu4924" rel="noreferrer"
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                                <YouTubeIcon sx={{ color: '#F0F0F0' }} fontSize="medium" />
                                                <span style={{ color: '#F0F0F0' }}> @md.hamidulislammintu4924</span>
                                            </div>
                                        </a>
                                    </div>
                                </div> */}
                            </Stack>
                            <Stack>
                                <h3
                                    style={{
                                        color: 'yellow',
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem',
                                        paddingBottom: '0.9rem',
                                        margin: '0',
                                    }}
                                >
                                    {' '}
                                    Pallabi Branch
                                </h3>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.3rem',
                                    }}
                                >
                                    <BusinessIcon
                                        sx={{ color: '#F0F0F0' }}
                                        fontSize="small"
                                    />
                                    <span style={{ color: '#F0F0F0' }}>
                                        {' '}
                                        House-15, Road-17, Block-D, Mirpur-12,
                                        Dhaka-1216
                                    </span>
                                </div>
                                <div
                                    style={{
                                        paddingTop: '1rem',
                                        alignItems: 'center',
                                        gap: '0.3rem',
                                    }}
                                >
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href="tel:+8801711969580"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <LocalPhoneIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                +88 01711 969580
                                            </span>
                                        </div>
                                    </a>
                                    {/* <a
                                        style={{ textDecoration: 'none' }}
                                        href="tel:+8801628212121"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <LocalPhoneIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                +88 01628 212121
                                            </span>
                                        </div>
                                    </a> */}
                                </div>
                                <div
                                    style={{
                                        paddingTop: '1rem',
                                        alignItems: 'center',
                                        gap: '1rem',
                                    }}
                                >
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href="mailto:info@chs.edu.bd"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <MailIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                info@chs.edu.bd
                                            </span>
                                        </div>
                                    </a>
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href="https://chs.edu.bd/"
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.3rem',
                                            }}
                                        >
                                            <LanguageIcon
                                                sx={{ color: '#F0F0F0' }}
                                                fontSize="small"
                                            />
                                            <span style={{ color: '#F0F0F0' }}>
                                                {' '}
                                                chs.edu.bd
                                            </span>
                                        </div>
                                    </a>
                                </div>
                                {/* <Stack
                                    justifyContent={'center'}
                                    direction={'column'}
                                    alignItems={'center'}
                                    sx={{ display: 'flex', mt: '0.2rem' }}
                                >
                                    <h3 style={{ color: '#F0F0F0', fontWeight: 'bold', marginBottom: '8px' }}>Social Media Links</h3>
                                </Stack>
                                <div>
                                    <div>
                                        <a
                                            target="_blank"
                                            style={{ textDecoration: 'none' }}
                                            href="https://www.facebook.com/profile.php?id=100057644492310" rel="noreferrer"
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                                <FacebookIcon sx={{ color: '#F0F0F0' }} fontSize="medium" />
                                                <span style={{ color: '#F0F0F0' }}> Charupath Hateykhari School</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div>
                                        <a
                                            target="_blank"
                                            style={{ textDecoration: 'none' }}
                                            href="https://www.youtube.com/@md.hamidulislammintu4924" rel="noreferrer"
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                                                <YouTubeIcon sx={{ color: '#F0F0F0' }} fontSize="medium" />
                                                <span style={{ color: '#F0F0F0' }}> @md.hamidulislammintu4924</span>
                                            </div>
                                        </a>
                                    </div>
                                </div> */}
                                {/* </Stack> */}
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Container>
        </Box>
        {/* Developer footer */}
        <Divider sx={{ backgroundColor: '#F0F0F0' }} />
        <Box
            sx={{
                backgroundColor: '#1a1a1a',
                // backgroundImage: 'linear-gradient(90deg, rgba(244, 80, 80, 1) -100%, rgba(55, 166, 71, 1) 110%)'
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent={'center'}
                    sx={{ padding: 0.5 }}
                    alignItems={'center'}
                    style={{
                        color: '#F0F0F0',
                        fontWeight: 'bold',
                        letterSpacing: '0.1rem',
                    }}
                >
                    <Stack
                        direction={'row'}
                        justifyContent={'center'}
                        alignItems={{ xs: 'self-start', sm: 'center' }}
                    >
                        <Typography
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}
                        >
                            <span>
                                <span
                                    style={{
                                        fontSize: '1.2em',
                                        marginRight: '0.3em',
                                        color: '#F9D949',
                                    }}
                                >
                                    ©️
                                </span>
                                <span>
                                    2023 - Charupath Hateykhari School (CHS) All
                                    Rights Reserved.
                                </span>
                            </span>
                        </Typography>
                    </Stack>
                    <Stack
                        direction={'row'}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        <img
                            src={dev}
                            alt="Dev"
                            style={{
                                margin: '0 .3rem 0.15rem .5rem',
                                backgroundColor: '#F9D949',
                                padding: '0.1rem',
                                borderRadius: '50%',
                                width: '1rem',
                            }}
                        />
                        <span style={{ fontSize: '0.7rem' }}>Developed by</span>
                        <Button
                            className="devfont"
                            sx={{
                                color: '#F9D949',
                                textShadow: '0 0 1px #F45050',
                                fontWeight: 'bold',
                                fontSize: '0.8rem',
                            }}
                            onClick={() =>
                                window.open('https://musamolla.com', '_blank')
                            }
                        >
                            Musa Molla
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    </>
);

export default PublicFooter;
